import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/useAuth';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-secondary-900">
        <span className="w-8 h-8 flex items-center justify-center text-primary-500 animate-spin">
          <i className="ri-loader-4-line text-2xl"></i>
        </span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}
